var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#FFF",
    viewBox: "0 0 24 17.33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28 8.39a1.34 1.34 0 0 0-1.89 1.89l6.67 6.66a1.33 1.33 0 0 0 1.88 0L23.61 2.28A1.34 1.34 0 0 0 21.72.39L8 14.11 2.28 8.39Z"
  })));
};
export { SvgCheck as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAxNy4zMyIgZmlsbD0iI0ZGRkZGRiI+CiAgICA8cGF0aCBkPSJNMi4yOCw4LjM5QTEuMzQsMS4zNCwwLDAsMCwuMzksMTAuMjhsNi42Nyw2LjY2YTEuMzMsMS4zMywwLDAsMCwxLjg4LDBMMjMuNjEsMi4yOEExLjM0LDEuMzQsMCwwLDAsMjEuNzIuMzlMOCwxNC4xMSwyLjI4LDguMzlaIiAvPgo8L3N2Zz4=";